import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'src/js/store';
import error from 'src/js/modules/error';
import App from './app';
import initApp from './init-app';

initApp().then(() => {
  const root = createRoot(document.getElementById('app'));

  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
});

error.operations.registerCatcher(error.helpers.errorCatcher);
